import React from 'react';
import { Info } from 'lucide-react';
interface SettingsToggleProps {
  id: string;
  label: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  tooltip?: string;
}
export const SettingsToggle: React.FC<SettingsToggleProps> = ({
  id,
  label,
  description,
  checked,
  onChange,
  disabled = false,
  tooltip
}) => {
  return <div className="flex items-center justify-between py-2" data-id="element-18960">
      <div className="flex-1" data-id="element-18961">
        <div className="flex items-center gap-2" data-id="element-18962">
          <label htmlFor={id} className="text-sm font-medium text-gray-900 dark:text-white cursor-pointer" data-id="element-18963">
            {label}
          </label>
          {tooltip && <div className="relative group" data-id="element-18964">
              <Info size={14} className="text-gray-400 cursor-help" data-id="element-18965" />
              <div className="absolute bottom-full left-0 mb-2 w-64 p-2 bg-gray-900 text-white text-xs rounded shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-10" data-id="element-18966">
                {tooltip}
                <div className="absolute top-full left-4 border-4 border-transparent border-t-gray-900" data-id="element-18967"></div>
              </div>
            </div>}
        </div>
        {description && <p className="mt-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-18968">
            {description}
          </p>}
      </div>
      <label className="relative inline-flex items-center cursor-pointer" data-id="element-18969">
        <input id={id} type="checkbox" className="sr-only" checked={checked} onChange={e => onChange(e.target.checked)} disabled={disabled} data-id="element-18970" />
        <div className={`relative w-11 h-6 bg-gray-200 rounded-full transition-colors ${checked ? 'bg-gradient-to-r from-pink-600 to-purple-600' : ''} ${disabled ? 'opacity-50' : ''}`} data-id="element-18971">
          <div className={`absolute top-1 left-1 bg-white w-4 h-4 rounded-full transition-transform ${checked ? 'transform translate-x-5' : ''}`} data-id="element-18972"></div>
        </div>
      </label>
    </div>;
};